import LanguageSwitch from "@/features/menu/settings/LanguageSwitch";
export default function Language() {
    return <LanguageSwitch />;
}
